import getOption from '@/src/utils/getOption';
import { useTranslations } from 'next-intl';

export default function SalesCost({
  excludingVat = false,
}: {
  excludingVat?: any;
}) {
  const t = useTranslations('SalesCost');
  return (
    <span className='block w-full px-6 text-center text-xs font-semibold uppercase'>
      {excludingVat
        ? t('messageExcluding', {
            vat: getOption('VAT_PERCENTAGE')
              ? getOption('VAT_PERCENTAGE') + '%'
              : '',
          })
        : t('messageIncluding', {
            vat: getOption('VAT_PERCENTAGE')
              ? getOption('VAT_PERCENTAGE') + '%'
              : '',
          })}
    </span>
  );
}
